import { render, staticRenderFns } from "./popup_migrate_verified_articles.vue?vue&type=template&id=14e6037b&lang=pug"
import script from "./popup_migrate_verified_articles.vue?vue&type=script&lang=js"
export * from "./popup_migrate_verified_articles.vue?vue&type=script&lang=js"
import style0 from "./popup_migrate_verified_articles.vue.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports